import { useEffect, useRef } from "react";

// eslint-disable-next-line
export const useTrackRef = function <T>(thing: T) {
  const ref = useRef(thing);

  useEffect(() => {
    ref.current = thing;
  }, [thing]);

  return ref;
};
